<template>
  <div v-loading="loading">
    <div class="title">挑战作品</div>
    <router-link
      v-if="homeworkId"
      :to="{ name: 'ChallnegeWorkDetail', params: { id: homeworkId } }"
    >
      <el-alert
        style="margin-bottom: 4px"
        title="您还有一份作品未完成批改，请尽快完成～"
        type="warning"
        :closable="false"
        show-icon
      >
      </el-alert>
    </router-link>
    <div class="search-box">
      <el-input
        clearable
        size="mini"
        @keyup.enter.native="handleSearch"
        placeholder="请输入挑战名称"
        class="w-180 mr-12"
        v-model="search.challenge_name"
      ></el-input>
      <el-input
        clearable
        size="mini"
        @keyup.enter.native="handleSearch"
        placeholder="请输入学员名称"
        class="w-160 mr-12"
        v-model="search.student_search"
      ></el-input>
      <el-input
        clearable
        size="mini"
        @keyup.enter.native="handleSearch"
        placeholder="请输入来源"
        class="w-160 mr-12"
        v-model="search.company_name"
      ></el-input>
      <el-button type="primary" size="mini" @click="handleSearch"
        >搜索</el-button
      >
      <el-button type="default" size="mini" @click="handleReset"
        >重置</el-button
      >
    </div>
    <el-table :data="homeworkList" :stripe="true">
      <el-table-column width="80" label="作品编号" prop="id"></el-table-column>
      <el-table-column width="120" label="学员">
        <template slot-scope="scope">
          <span v-if="scope.row.student">{{ scope.row.student.name }}</span>
          <span v-else-if="scope.row.source">{{
            scope.row.source.platform_student_name
          }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="挑战名称" prop="challenge.name">
        <template slot-scope="scope">
          <el-link :underline="false" @click="watchDemand(scope.row)">{{
            (scope.row.challenge || {}).name
          }}</el-link>
        </template>
      </el-table-column>
      <el-table-column width="140" label="来源" prop="company_name">
        <template slot-scope="scope">{{
          scope.row.challenge_work_source.name
        }}</template>
      </el-table-column>
      <el-table-column width="100" label="提交次数">
        <template slot-scope="scope">第 {{ scope.row.times }} 次提交</template>
      </el-table-column>
      <el-table-column width="210" label="批改倒计时">
        <template slot-scope="scope">
          <countdown
            :key="scope.row.id"
            :created-time="scope.row.created_at"
          ></countdown>
        </template>
      </el-table-column>
      <el-table-column
        width="75"
        label="状态"
        prop="status_label"
      ></el-table-column>
      <el-table-column width="100">
        <template slot="header">
          <div @click="toggleShowContent" class="toggle-show">
            <span>批改价格</span>
            <i class="el-icon-view toggle-show-icon"></i>
          </div>
        </template>
        <template slot-scope="scope">
          <show-hide-content
            :value="scope.row.teacher_evaluate_price || 0"
            :show.sync="isShow"
          ></show-hide-content>
        </template>
      </el-table-column>
      <el-table-column width="55" label="操作" fixed="right">
        <template slot-scope="scope">
          <el-link
            type="primary"
            :underline="false"
            @click="grabOrder(scope.row.id)"
            >抢单</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total, prev, pager, next, jumper"
      @current-change="handleChangePage"
      :current-page.sync="pagination.currentPage"
      :page-size="pagination.pageSize"
      :total="pagination.total"
      :hide-on-single-page="true"
    >
    </el-pagination>
    <el-dialog
      :visible.sync="show"
      title="挑战要求"
      :before-close="handleCloseDialog"
    >
      <el-card shadow="hover">
        <div slot="header">
          <span class="brand-color mb-12">{{ project_name }}</span>
        </div>
        <div
          v-for="(item, index) in project_content"
          :key="index"
          class="md-border"
        >
          <markdown-it
            class="jk-md-it"
            :md="(item.content || {}).html"
          ></markdown-it>
        </div>
      </el-card>
    </el-dialog>
  </div>
</template>

<script>
// import { mapState } from "vuex";
import challengeService from "@/global/service/challenge";
import Countdown from "@/components/Countdown.vue";
import ShowHideContent from "@/components/ShowHideContent";
import MarkdownIt from "@jiker/markdown-it/MarkdownIt.vue";
export default {
  components: {
    Countdown,
    ShowHideContent,
    MarkdownIt
  },
  data() {
    return {
      loading: true,
      isShow: false,
      homeworkId: null,
      homeworkList: [],
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0
      },
      search: {
        challenge_name: null,
        student_search: null,
        company_name: null
      },
      currentMd: "",
      show: false,
      project_content: [],
      project_name: ""
    };
  },
  // computed: {
  //   ...mapState(["authPermissions"])
  // },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      const params = {
        page: this.pagination.currentPage,
        page_size: this.pagination.pageSize,
        ...this.search
      };
      this.loading = true;
      challengeService
        .challengesWork(params)
        .then(res => {
          this.homeworkList = res.list;
          this.pagination.currentPage = res.pagination.current_page;
          this.pagination.total = res.pagination.total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSearch() {
      this.pagination.currentPage = 1;
      this.getData();
    },
    handleReset() {
      this.search = {
        project_name: null,
        student_name: null
      };
      this.pagination.currentPage = 1;
      this.getData();
    },
    handleChangePage(e) {
      this.pagination.currentPage = e;
      this.getData();
    },
    grabOrder(id) {
      if (this.loading) return;
      // if (this.homeworkId) {
      //   this.$alert("有未完成的作品批改，请先完成！", "提示", {
      //     confirmButtonText: "去批改",
      //     type: "warning",
      //     center: true,
      //     callback: res => {
      //       if (res === "confirm") {
      //         this.$router.push({
      //           name: "ChallnegeWorkDetail",
      //           params: { id: this.homeworkId }
      //         });
      //       }
      //     }
      //   });
      //   return;
      // }
      this.loading = true;
      challengeService
        .challengeWorkGrab({ challenge_work_id: id })
        .then(() => {
          this.$message.success("抢单成功～");
          this.$router.push({
            name: "ChallengeWorkDetail",
            params: { id }
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    toggleShowContent() {
      this.isShow = !this.isShow;
    },
    watchDemand(item) {
      this.project_content = item.project_content;
      this.challenge_name = item.challenge.name;
      this.show = true;
    },
    handleCloseDialog() {
      this.show = false;
      this.project_content = [];
      this.project_name = "";
    }
  }
};
</script>

<style lang="less" scoped>
.search-box {
  margin: 20px 0 10px;
}
.md-border {
  padding: 10px;
  border-bottom: 1px solid #efefef;
  margin-bottom: 12px;
  &:last-child {
    border: none;
  }
}
.dialog-title {
  font-size: 20px;
  margin-bottom: 12px;
}
</style>
